import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Node3D } from '../../../base/node3d/Component';
import { useGizmoDrawn } from '../../../../r3f/hooks/useGizmoState';
import { useSceneResources } from '../../../../r3f/SceneResourcesContext';
import { useSubOrExtResource } from '../../../../resources/useSubOrExtResource';
import { ShapeCastGizmo } from './ShapeCastGizmo';
import { DEFAULT_ENABLED, DEFAULT_TARGET_POSITION } from './types';
export function ShapeCast3D({ node, children }) {
    const props = node.properties;
    const sceneResources = useSceneResources();
    const shape = useSubOrExtResource(props.shape, sceneResources)?.resource ?? null;
    const drawsGizmo = useGizmoDrawn('every-node');
    return (_jsxs(Node3D, { node: node, children: [drawsGizmo && (_jsx(ShapeCastGizmo, { target: props.target_position ?? DEFAULT_TARGET_POSITION, shape: shape, customColor: props.debug_shape_custom_color, enabled: props.enabled ?? DEFAULT_ENABLED })), children] }));
}
//# sourceMappingURL=Component.js.map